import EmptySection from '@/components/EmptySection';
import StudentViewSection from '@/components/StudentViewSection';
import WorkshopSection from '@/components/WorkshopSection';
import Constants from '@/Constants';
import { useContentLanguageChange } from '@/hooks/useContentLanguageChange';
import { useGetPaginated } from '@/hooks/useGetPaginated';
import { ViewType } from '@/models/ViewType';
import { ApplicationState } from '@/store';
import { coursesTrainingsClear } from '@/store/list/action';
import { CourseStudentView } from '@/store/list/types';
import { programsTrainingsClear } from '@/store/program/action';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import './style.scss';

const TRAINING_ENROLLED_STUDENT_VIEW_TYPE = 'listTrainingsEnrolledStudentView';

const getQueryParams = (offset: number, limit: number) => {
    let queryParams = `?moduleIds=${Constants.LMS_MODULE_ID}&section=WORKSHOP`;

    if (_.isNumber(offset)) {
        queryParams += `&offset=${offset}`;
    }
    if (_.isNumber(limit)) {
        queryParams += `&limit=${limit}`;
    }

    return queryParams;
};

const limit: number = 12;

const TrainingsPage: React.FC = () => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);
    const personId = useSelector((state: ApplicationState) => state.identity.data.person.id);
    const dispatch = useDispatch();

    const [refreshSection, setRefreshSection] = useState<boolean>(true);

    const getKey = useCallback(
        (index: number) => {
            const offset: number = index * limit;

            const queryParams = getQueryParams(offset, limit);
            return Constants.LMS_STUDENT_COURSES_URI.replace('%s', `${personId}`) + queryParams;
        },
        [personId],
    );

    const { data: workshopData, loading: workshopLoading, revalidateResult } = useGetPaginated<CourseStudentView>(getKey, {
        revalidateOnMount: true,
    });

    const noTrainingResults = useSelector(
        (state: ApplicationState) =>
            !state.lists.listData[TRAINING_ENROLLED_STUDENT_VIEW_TYPE].loading &&
            !state.program.listData[TRAINING_ENROLLED_STUDENT_VIEW_TYPE].loading &&
            !workshopLoading &&
            state.lists.listData[TRAINING_ENROLLED_STUDENT_VIEW_TYPE].total === 0 &&
            state.program.listData[TRAINING_ENROLLED_STUDENT_VIEW_TYPE].total === 0 &&
            workshopData.length === 0,
    );

    useContentLanguageChange({
        onChange: () => {
            revalidateResult();
            dispatch(coursesTrainingsClear());
            dispatch(programsTrainingsClear());
            setTimeout(() => setRefreshSection(true), 100);
        },
        unmountChange: () => {
            dispatch(coursesTrainingsClear());
            dispatch(programsTrainingsClear());
            setRefreshSection(false);
        },
    });

    return (
        <>
            <div className="trainings">
                {noTrainingResults ? (
                    <div className="empty-section-container">
                        <EmptySection iconName={Constants.icons.SMS_FAILED} message={strings.EMPTY_SECTION_MESSAGE} />
                    </div>
                ) : (
                    <>
                        <div className="trainings__title-container container">
                            <span className="title">{strings.TRAINING_PAGE.TITLE}</span>
                        </div>
                        <div className="container">
                            <WorkshopSection data={workshopData} />
                        </div>
                        <div className="trainings__content-container">
                            {refreshSection && (
                                <StudentViewSection
                                    dynamicTitle={strings.TRAINING_PAGE.DYNAMIC_TITLE}
                                    viewType={'listTrainingsEnrolledStudentView' as ViewType}
                                />
                            )}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
export default TrainingsPage;
